import React, { useState, useEffect } from "react";
import Cookies from 'js-cookie';
import profileIcon from "../../assets/profile-icon.png";
import logoIcon from "../../assets/logo-icon.png";

const translations = {
  en: {
    candidate: "Candidate",
    hiringInsight: "Hiring Insight",
    careerAdvice: "Career Advice",
    keyTraits: "Key Traits",
    yourKeyTraits: "Your Key Traits",
    keyStrengths: "Key Strengths",
    yourStrengths: "Your Strengths",
    noStrengthAreas: "No strength areas"
  },
  nl: {
    candidate: "Kandidaat",
    hiringInsight: "Wervingsinzicht",
    careerAdvice: "Carrière Advies",
    keyTraits: "Belangrijkste Eigenschappen",
    yourKeyTraits: "Jouw Belangrijkste Eigenschappen",
    keyStrengths: "Belangrijkste Sterke Punten",
    yourStrengths: "Jouw Sterke Punten",
    noStrengthAreas: "Geen sterke punten"
  }
};

const getProfileImage = (linkedInData) => {
  if (!linkedInData) return profileIcon;

  const isValidUrl =
    linkedInData.displayPictureUrl &&
    linkedInData.displayPictureUrl !== "null" &&
    linkedInData.displayPictureUrl !== "nullnull" &&
    !linkedInData.displayPictureUrl.includes("null");

  if (!isValidUrl) return profileIcon;

  const imageSize = linkedInData?.img_800_800 || linkedInData?.img_400_400 || linkedInData?.img_200_200 || linkedInData?.img_100_100 || "";
  return `${linkedInData.displayPictureUrl}${imageSize}`;
};

const ProfileHeader = ({
  linkedInData,
  analysisResults,
  isRecruiterMode,
  isGeneratingPDF,
  isDutch = false
}) => {
  const [lang, setLang] = useState(isDutch ? 'nl' : 'en');
  const t = translations[lang];

  useEffect(() => {
    const checkLanguage = () => {
      const cookieIsDutch = Cookies.get('isDutch') === 'true';
      const newLang = cookieIsDutch ? 'nl' : 'en';
      if (newLang !== lang) {
        setLang(newLang);
      }
    };

    // Check immediately
    checkLanguage();

    // Set up an interval to check for changes
    const interval = setInterval(checkLanguage, 1000);

    return () => clearInterval(interval);
  }, [lang]);

  return (
    <div className="mt-4 border rounded-md w-full h-fi animate-text">
      <div className="p-4 ">
        <div className="flex items-center gap-4">
         
          <img
            src={profileIcon}
            className="w-16 h-16 rounded-full animate-text"
            alt="Profile"
          />
        
          <span>
            <h2 className="text-2xl font-bold animate-text mt-neg text-primary1">
              {linkedInData?.firstName ? `${linkedInData.firstName} ${linkedInData.lastName}` : t.candidate}
            </h2>
            <p className="text-gray-500 animate-text mt-neg">
              {linkedInData ? linkedInData.headline : ""}
            </p>
          </span>
        </div>

        {isRecruiterMode ? (
          <div className={`${linkedInData && "mt-4"} mb-2`}>
            <h1 className="font-bold mb-1">{t.personalitySummary}</h1>
            <p className="">{analysisResults.summary.dominantTraits}</p>
            {analysisResults.summary.hiringInsights && (
              <div className="p-4 rounded-md mt-4 gradient-bg-2 animate-text">
                <span className="text-primary text-sm font-bold animate-text mb-1 mt-neg flex items-center gap-2 bg-white py-1.5 px-3 pr-4 rounded-full w-fit mb-4">
                  <img src={logoIcon} className="size-4" />
                  <h3>{t.hiringInsight}</h3>
                </span>
                <p className="mt-neg">
                  {analysisResults.summary.hiringInsights}
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className={`${linkedInData && "mt-4"} mb-2`}>
            <h1 className="font-bold mb-1">{t.personalitySummary}</h1>
            <p>{analysisResults.summary.dominantTraits}</p>
            {analysisResults.summary.careerAdvice && (
              <div className="p-4 rounded-md mt-4 gradient-bg-2 animate-text">
                <span className="text-primary text-sm font-bold animate-text mb-1 mt-neg flex items-center gap-2 bg-white py-1.5 px-3 pr-4 rounded-full w-fit mb-4">
                <img src={logoIcon} className="size-4" />
                  <h3>{t.careerAdvice}</h3>
                </span>
                <p>{analysisResults.summary.careerAdvice}</p>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="border-top p-4">
        <div className="">
          <h3 className="font-bold animate-text mb-1">
            {isRecruiterMode ? t.keyTraits : t.yourKeyTraits}
          </h3>
          <div className="text-sm flex flex-wrap gap-1">
            {analysisResults.summary.keyTraits.map((trait, i) => (
              <span key={i} className="p-2 rounded-md gradient-bg-1">
                <p className="mt-neg">
                  {trait.charAt(0).toUpperCase() + trait.slice(1)}
                </p>
              </span>
            ))}
          </div>
        </div>
        <div className="mt-4">
          <h3 className="font-bold animate-text mb-1">
            {isRecruiterMode ? t.keyStrengths : t.yourStrengths}
          </h3>
          <div className="text-sm flex flex-wrap gap-1">
            {analysisResults?.recommendations?.jobFitAnalysis?.strengthAreas &&
            analysisResults.recommendations.jobFitAnalysis.strengthAreas
              .length > 0 ? (
              analysisResults.recommendations.jobFitAnalysis.strengthAreas.map(
                (strength, i) => (
                  <span key={i} className="p-2 rounded-md gradient-bg-1">
                    <p className="mt-neg">{strength}</p>
                  </span>
                )
              )
            ) : (
              <span className="p-2 rounded-md gradient-bg-1">
                {t.noStrengthAreas}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
